/* PawDent — בוקס קנייה. לוגיקת בורר חבילות + וריאנטים + הוספה לעגלה (AJAX). */
(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.pdbbInit === 'true') return;
    root.dataset.pdbbInit = 'true';

    var addBtns = Array.prototype.slice.call(root.querySelectorAll('[data-pdbb-add]'));
    var addLabels = Array.prototype.slice.call(root.querySelectorAll('[data-pdbb-add-label]'));
    var spinner = root.querySelector('.pdbb__atc-spinner');
    var feedback = root.querySelector('[data-pdbb-feedback]');
    var priceEls = Array.prototype.slice.call(root.querySelectorAll('[data-pdbb-price]'));
    var compareEl = root.querySelector('[data-pdbb-compare]');

    var state = {
      variantId: root.dataset.variantId ? String(root.dataset.variantId) : '',
      quantity: 1
    };

    /* ---- וריאנטים ---- */
    var variants = [];
    var variantsScript = root.querySelector('[data-pdbb-variants]');
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { variants = []; }
    }

    function selectedOptionValues() {
      var inputs = root.querySelectorAll('[data-pdbb-option-input]:checked');
      return Array.prototype.map.call(inputs, function (i) { return i.value; });
    }

    /* עיצוב מחיר לפי פורמט הכסף של החנות */
    function formatMoney(cents) {
      var fmt = root.dataset.moneyFormat || '₪{{amount}}';
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, (cents / 100).toFixed(2));
    }

    /* מחיר חבילה: כמות × יחידה פחות הנחה, מעוגל לשקל שלם פחות 10 אגורות (זהה ל-Liquid) */
    function bundlePriceCents(unitCents, qty, disc) {
      var base = unitCents * qty;
      if (!disc) return base;
      var raw = base * (100 - disc) / 100;
      return Math.round(raw / 100) * 100 - 10;
    }

    /* עדכון מחירי החבילות לפי הווריאנט הנבחר */
    function updateBundlePrices(v) {
      bundles.forEach(function (label) {
        var priceEl = label.querySelector('[data-pdbb-bundle-price]');
        if (!priceEl) return; /* מצב ידני — לא נוגעים */
        var qty = parseInt(label.dataset.quantity, 10) || 1;
        var disc = parseInt(label.dataset.discount, 10) || 0;
        priceEl.textContent = formatMoney(bundlePriceCents(v.price, qty, disc));
        var cmp = label.querySelector('[data-pdbb-bundle-compare]');
        if (!cmp) return;
        if (disc > 0) {
          cmp.textContent = formatMoney(v.price * qty);
          cmp.hidden = false;
        } else if (v.compare_at_price && v.compare_at_price > v.price) {
          cmp.textContent = formatMoney(v.compare_at_price * qty);
          cmp.hidden = false;
        } else {
          cmp.hidden = true;
        }
      });
    }

    function matchVariant() {
      if (!variants.length) return;
      var chosen = selectedOptionValues();
      var found = variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, idx) { return o === chosen[idx]; });
      });
      if (found) {
        state.variantId = String(found.id);
        root.dataset.variantId = state.variantId;
        if (found.price_formatted) {
          priceEls.forEach(function (el) { el.textContent = found.price_formatted; });
        }
        if (compareEl) {
          if (found.compare_at_price && found.compare_at_price > found.price) {
            compareEl.textContent = found.compare_formatted;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        setAddDisabled(!found.available);
        updateBundlePrices(found);
      }
    }

    root.querySelectorAll('[data-pdbb-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var group = input.closest('.pdbb__variant-pills');
        if (group) {
          group.querySelectorAll('.pdbb__variant-pill, .pdbb__swatch').forEach(function (p) {
            p.classList.remove('pdbb__variant-pill--selected', 'pdbb__swatch--selected');
          });
          var pill = input.closest('.pdbb__variant-pill');
          if (pill) pill.classList.add('pdbb__variant-pill--selected');
          var swatch = input.closest('.pdbb__swatch');
          if (swatch) swatch.classList.add('pdbb__swatch--selected');
        }
        // עדכון שם הצבע הנבחר ליד הכותרת
        var fieldset = input.closest('.pdbb__variant-group');
        var nameEl = fieldset ? fieldset.querySelector('[data-pdbb-option-selected]') : null;
        if (nameEl) nameEl.textContent = input.value;
        matchVariant();
      });
    });

    /* ---- חבילות (כמות) ---- */
    var bundles = root.querySelectorAll('[data-pdbb-bundle]');
    function syncBundle(selectedLabel) {
      bundles.forEach(function (b) { b.classList.remove('pdbb__bundle--selected'); });
      if (selectedLabel) {
        selectedLabel.classList.add('pdbb__bundle--selected');
        state.quantity = parseInt(selectedLabel.dataset.quantity, 10) || 1;
      }
    }
    bundles.forEach(function (label) {
      var input = label.querySelector('[data-pdbb-bundle-input]');
      if (!input) return;
      if (input.checked) state.quantity = parseInt(label.dataset.quantity, 10) || 1;
      input.addEventListener('change', function () { if (input.checked) syncBundle(label); });
    });

    /* ---- מצב כפתור ---- */
    function setAddDisabled(disabled) {
      addBtns.forEach(function (b) { b.disabled = !!disabled; });
    }
    function setLoading(loading) {
      addBtns.forEach(function (b) { b.disabled = loading; });
      if (spinner) spinner.hidden = !loading;
      addLabels.forEach(function (l) { l.style.opacity = loading ? '0.6' : '1'; });
    }
    function showFeedback(msg, kind) {
      if (!feedback) return;
      feedback.textContent = msg;
      feedback.hidden = false;
      feedback.classList.remove('pdbb__feedback--ok', 'pdbb__feedback--err');
      feedback.classList.add(kind === 'err' ? 'pdbb__feedback--err' : 'pdbb__feedback--ok');
    }

    /* ---- הוספה לעגלה ---- */
    function afterAdd(data) {
      var action = root.dataset.cartAction || 'drawer';
      if (action === 'cart') { window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart' : '/cart'; return; }
      if (action === 'none') { showFeedback('נוסף לעגלה בהצלחה ✓', 'ok'); return; }

      // עדכון בועת העגלה בכותרת (Section Rendering של שופיפיי)
      if (data && data.sections && data.sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
      }

      // הדרך הרשמית של תמות מבוססות Dawn: המגירה מעדכנת את עצמה ונפתחת
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
        try {
          drawer.renderContents(data);
          // רשת ביטחון: אם אחרי הרענון המגירה לא באמת מציגה פריטים — רענון עמוד ופתיחה אוטומטית
          setTimeout(function () {
            if (!document.querySelector('#CartDrawer .cart-item')) {
              try { sessionStorage.setItem('pdbbOpenCart', '1'); } catch (err) {}
              window.location.reload();
            }
          }, 300);
          return;
        } catch (e) {}
      }

      // נפילה אחורה: אירועים כלליים + פתיחה ידנית
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
      var anyDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, #cart-drawer');
      var opened = false;
      if (anyDrawer) {
        if (typeof anyDrawer.open === 'function') { try { anyDrawer.open(); opened = true; } catch (e) {} }
        if (!opened) {
          anyDrawer.classList.add('active', 'is-open', 'open');
          anyDrawer.removeAttribute('hidden');
          document.body.classList.add('cart-drawer-open');
          opened = true;
        }
      }
      if (!opened) { showFeedback('נוסף לעגלה בהצלחה ✓', 'ok'); }
    }

    function addToCart() {
      if (!state.variantId) { showFeedback('לא נבחר וריאנט זמין', 'err'); return; }
      setLoading(true);
      if (feedback) feedback.hidden = true;
      var body = { items: [{ id: Number(state.variantId), quantity: state.quantity }] };
      postAdd(body, function (ok, data) {
        setLoading(false);
        if (!ok) { showFeedback(data && data.description ? data.description : 'ההוספה נכשלה, נסו שוב', 'err'); return; }
        afterAdd(data);
      });
    }

    /* שליחת הוספה לעגלה + בקשת ה-HTML המעודכן של המגירה והבועה (Section Rendering) */
    function postAdd(body, done) {
      var sectionNames = [];
      if (document.querySelector('cart-drawer')) sectionNames.push('cart-drawer');
      if (document.getElementById('cart-icon-bubble')) sectionNames.push('cart-icon-bubble');
      if (sectionNames.length) {
        body.sections = sectionNames;
        body.sections_url = window.location.pathname;
      }
      var addUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (data) { done(res.ok, data); }); })
        .catch(function () { done(false, null); });
    }

    addBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

    /* ---- גלריה: תמונה ראשית + חצים + תמונות ממוזערות (כל הגדלים) ---- */
    var gallery = root.querySelector('[data-pdbb-gallery]');
    if (gallery) {
      var slides = gallery.querySelectorAll('.pdbb__slide');
      var thumbsWrap = root.querySelector('[data-pdbb-thumbs]');
      var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-pdbb-thumb]') : [];
      var prevBtn = root.querySelector('[data-pdbb-prev]');
      var nextBtn = root.querySelector('[data-pdbb-next]');
      var smooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      var slideIndex = 0;

      function setCurrent(idx) {
        slideIndex = idx;
        Array.prototype.forEach.call(thumbs, function (t, i) {
          t.classList.toggle('pdbb__thumb--current', i === idx);
          if (i === idx) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        var current = thumbs[idx];
        // מיישרים את פס התמונות הממוזערות רק כשהוא באמת על המסך — אחרת
        // scrollIntoView גורר את כל העמוד לגלריה בכל טעינה/רינדור מחדש בעורך
        if (current && current.scrollIntoView && thumbsWrap) {
          var tr = thumbsWrap.getBoundingClientRect();
          if (tr.bottom > 0 && tr.top < window.innerHeight) {
            current.scrollIntoView({ behavior: smooth, block: 'nearest', inline: 'nearest' });
          }
        }
      }

      function goTo(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx > slides.length - 1) idx = 0;
        var slide = slides[idx];
        if (slide) slide.scrollIntoView({ behavior: smooth, block: 'nearest', inline: 'start' });
        setCurrent(idx);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(slideIndex - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(slideIndex + 1); });

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          goTo(parseInt(thumb.dataset.index, 10) || 0);
        });
      });

      if ('IntersectionObserver' in window && slides.length > 1) {
        var gio = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = Array.prototype.indexOf.call(slides, entry.target);
              setCurrent(idx);
            }
          });
        }, { root: gallery, threshold: 0.6 });
        slides.forEach(function (sl) { gio.observe(sl); });
      }
    }

    /* ---- אפסיילים: בחירת אופציות (צבע/מידה) + כפתור הוספה מיידי לסל ---- */
    root.querySelectorAll('[data-pdbb-upsell]').forEach(function (u) {
      var addBtn = u.querySelector('[data-pdbb-upsell-add]');
      if (!addBtn) return;
      var idleEl = u.querySelector('[data-pdbb-upsell-idle]');
      var doneEl = u.querySelector('[data-pdbb-upsell-done]');
      var priceEl = u.querySelector('[data-pdbb-upsell-price]');
      var imgEl = u.querySelector('[data-pdbb-upsell-img]');
      var dataEl = u.querySelector('[data-pdbb-upsell-data]');
      var variants = null;
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent).variants; } catch (err) {}
      }

      function setDone(done) {
        u.classList.toggle('pdbb__upsell--selected', done);
        if (idleEl) idleEl.hidden = done;
        if (doneEl) doneEl.hidden = !done;
      }

      function syncVariant() {
        if (!variants) return;
        var opts = [];
        u.querySelectorAll('[data-pdbb-upsell-opt]:checked').forEach(function (r) {
          opts[parseInt(r.dataset.optIndex, 10)] = r.value;
        });
        var match = null;
        for (var i = 0; i < variants.length; i++) {
          var same = true;
          for (var j = 0; j < variants[i].options.length; j++) {
            if (opts[j] !== undefined && variants[i].options[j] !== opts[j]) { same = false; break; }
          }
          if (same) { match = variants[i]; break; }
        }
        setDone(false);
        if (match) {
          addBtn.dataset.variantId = match.id;
          addBtn.disabled = !match.available;
          if (idleEl) idleEl.textContent = match.available ? 'הוספה לסל' : 'אזל מהמלאי';
          if (priceEl) priceEl.textContent = '(+' + formatMoney(match.price) + ')';
          if (imgEl && match.image) imgEl.src = match.image;
        } else {
          addBtn.disabled = true;
          if (idleEl) idleEl.textContent = 'הצירוף לא זמין';
        }
      }

      u.querySelectorAll('[data-pdbb-upsell-opt]').forEach(function (r) {
        r.addEventListener('change', syncVariant);
      });

      addBtn.addEventListener('click', function () {
        var vid = addBtn.dataset.variantId;
        if (!vid || addBtn.disabled) return;
        addBtn.disabled = true;
        postAdd({ items: [{ id: Number(vid), quantity: 1 }] }, function (ok, data) {
          addBtn.disabled = false;
          if (!ok) { showFeedback(data && data.description ? data.description : 'ההוספה נכשלה, נסו שוב', 'err'); return; }
          setDone(true);
          afterAdd(data);
        });
      });

      syncVariant();
    });

    /* ---- ביקורות: חץ בודד שמדפדף קדימה במעגל (מהאחרונה חוזר לראשונה) ---- */
    root.querySelectorAll('[data-pdbb-carousel]').forEach(function (rev) {
      var revTrack = rev.querySelector('.pdbb__reviews-track');
      var revNext = rev.querySelector('[data-pdbb-rev-next]');
      if (!revTrack || !revNext) return;
      var revSmooth = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      revNext.addEventListener('click', function () {
        var count = revTrack.children.length;
        if (!count) return;
        var step = revTrack.clientWidth + 12;
        var index = Math.round(Math.abs(revTrack.scrollLeft) / step);
        if (index >= count - 1) {
          revTrack.scrollTo({ left: 0, behavior: revSmooth });
        } else {
          // RTL: קדימה = שמאלה = דלתא שלילית
          revTrack.scrollBy({ left: -step, behavior: revSmooth });
        }
      });
    });

    /* ---- סרגל קנייה דביק: מופיע כשכפתור הקנייה הראשי יוצא מהמסך ---- */
    var sticky = root.querySelector('[data-pdbb-sticky]');
    var mainBtn = root.querySelector('.pdbb__cta [data-pdbb-add]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('[data-pdbb-add]');
      var sio = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        sticky.classList.toggle('pdbb__sticky--shown', !visible);
        sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
        if (stickyBtn) stickyBtn.tabIndex = visible ? -1 : 0;
      }, { threshold: 0 });
      sio.observe(mainBtn);
    }

    /* ---- ציר משלוח: ספירה לאחור עד סגירת ההזמנות + תאריכים אוטומטיים ---- */
    var countdownEl = root.querySelector('[data-pdbb-countdown]');
    if (countdownEl) {
      var cutoffHour = parseInt(countdownEl.dataset.cutoffHour, 10);
      if (isNaN(cutoffHour)) cutoffHour = 14;
      var tick = function () {
        var now = new Date();
        var target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
        if (target <= now) target.setDate(target.getDate() + 1);
        var diff = Math.max(0, Math.floor((target - now) / 1000));
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var sec = diff % 60;
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };
        countdownEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
      };
      tick();
      setInterval(tick, 1000);
    }

    root.querySelectorAll('[data-pdbb-step-date][data-days]').forEach(function (el) {
      var days = parseInt(el.dataset.days, 10);
      if (isNaN(days) || days <= 0) return;
      var d = new Date();
      d.setDate(d.getDate() + days);
      try {
        el.textContent = d.toLocaleDateString('he-IL', { weekday: 'short', day: 'numeric', month: 'short' });
      } catch (e) {
        el.textContent = d.getDate() + '/' + (d.getMonth() + 1);
      }
    });

    /* ---- מדריך מידות: dialog נייטיבי — Escape, כפתור סגירה ולחיצת רקע סוגרים ---- */
    var sizeGuide = root.querySelector('[data-pdbb-size-guide]');
    if (sizeGuide) {
      root.querySelectorAll('[data-pdbb-size-guide-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof sizeGuide.showModal === 'function') sizeGuide.showModal();
          else sizeGuide.setAttribute('open', '');
        });
      });
      var sgClose = sizeGuide.querySelector('[data-pdbb-modal-close]');
      if (sgClose) sgClose.addEventListener('click', function () { sizeGuide.close(); });
      // לחיצה על הרקע (מחוץ לכרטיס) סוגרת
      sizeGuide.addEventListener('click', function (e) {
        if (e.target === sizeGuide) sizeGuide.close();
      });
    }

    /* ---- מדריך מידות: לשוניות קטגוריה ---- */
    var sgTabs = Array.prototype.slice.call(root.querySelectorAll('[data-pdbb-sg-tab]'));
    var sgPanels = Array.prototype.slice.call(root.querySelectorAll('[data-pdbb-sg-panel]'));
    sgTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-pdbb-sg-tab');
        sgTabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('pdbb__sg-tab--active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        sgPanels.forEach(function (p) {
          p.hidden = p.getAttribute('data-pdbb-sg-panel') !== idx;
        });
      });
    });

    // אתחול ראשוני
    var preselected = root.querySelector('[data-pdbb-bundle-input]:checked');
    if (preselected) syncBundle(preselected.closest('[data-pdbb-bundle]'));
    matchVariant();
  }

  function initAll() {
    document.querySelectorAll('[data-pdbb]').forEach(initSection);
    // המשך לרענון-הביטחון: אחרי reload פותחים את המגירה עם הפריטים מהשרת
    try {
      if (sessionStorage.getItem('pdbbOpenCart') === '1') {
        sessionStorage.removeItem('pdbbOpenCart');
        var dr = document.querySelector('cart-drawer');
        if (dr && typeof dr.open === 'function') {
          setTimeout(function () { dr.open(); }, 350);
        }
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // תמיכה ב-Theme Editor (טעינת סקשן מחדש)
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-pdbb]').forEach(function (el) {
      try { initSection(el); } catch (err) { console.error('pdbb init', err); }
    });
  });
})();
